import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Shown while a legacy org-scoped deep link is switching the active org (see
 * useSyncActiveOrgFromUrl). It gates the page so the project never paints under the
 * old org before the switch/reload lands.
 */
const SwitchingOrgLoader = () => (
  <Box
    sx={{
      width: "100%",
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
    }}
  >
    <CircularProgress sx={{ color: "#239B8B" }} />
    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#606971" }}>Switching organization…</Typography>
  </Box>
);

export default SwitchingOrgLoader;
